export default __webpack_public_path__ + "static/media/y.557e4b4d.svg";